import { Global } from '../Global';
import { post } from '../utils/ApiUtil';

export interface ProductDetailDTO {
  id: string;
  name: string;
  headImageUrl: string;
  standardPrice: number;
  trialPrice: number;
  standardDescription?: string;
  trialDescription?: string;
  sellerId?: string;
}

const getProductDetail = async (productId: string): Promise<ProductDetailDTO | null> => {
  if (Global.isMockMode()) {
    return Global.getMockData(`getProductDetail_${productId}`) as ProductDetailDTO | null;
  }
  const result = await post<{ id: string }, ProductDetailDTO>(
    '/product/getProductDetail',
    { id: productId },
  );
  if (typeof result === 'string') {
    return null;
  }
  return result;
};

export const ProductApi = {
  getProductDetail,
};
